import React, { useState, useEffect, useContext } from 'react'
import '../../src/assets/AdminCss/Menu.css'
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext, base_url } from "../context/Authcontext";
import toast from "react-hot-toast";
import axios from "axios";

const Menu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {logout, userdata, isAuthenticated, login, setIsAuthenticated } =
      useContext(AuthContext);
    const [aviator, setAviator] = useState();
    const [ludo, setLudo] = useState();
    const [active, setactive] = useState(false);
     const [toastActive2, setToastActive2] = useState(false);

      const handleClicktoast2 = () => {
    if (!toastActive2) {
      setToastActive2(true);
      toast.success("Coming soon", {
        onClose: () => setToastActive2(false), // 🔁 Re-enable after toast closes
      });
    }
  };

    const allowedPaths = [
        "/",
        "/cricketBet",
        "/sportall",
        "/cricketreal",
        "/footballreal",
        "/tennisreal",
        "/inplay",
        "/casinoGames",
    ];

    const handleSubmit = async () => {
        const token = localStorage.getItem('game_token');
        try {
            const response = await axios.post(base_url + '/api/webapi/casinoLobby', { token },
                {
                    withCredentials: true,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            )

            if (response?.data.success) {
                window.location.href = response?.data.url;
            } else {
                toast.error(response?.data.message);
            }

        } catch (err) {
            console.log(err);
        }
    }

    const handleGames = async () => {
        try {
            const token = localStorage.getItem('game_token');
            const response = await axios.get(base_url + '/api/webapi/particularGame', {
                params: {
                    token,
                    provider: 'SPB',
                },
                withCredentials: true,
                headers: {
                    'content-type': 'application/json',
                },
            });

            const games = response?.data?.items;
            const avia = games?.filter(game => game?.name.includes('Aviator'));
            const id = avia[0]?.id;
            setAviator(id);

        } catch (err) {
            console.log(err);
        }
    }

    const handleGames1 = async () => {
        try {
            const token = localStorage.getItem('game_token');
            const response = await axios.get(base_url + '/api/webapi/particularGame', {
                params: {
                    token,
                    provider: 'JIL',
                },
                withCredentials: true,
                headers: {
                    'content-type': 'application/json',
                },
            });

            const games = response?.data?.items;
            const avia = games?.filter(game => game?.name.includes('Ludo'));
            const id = avia[0]?.id;
            setLudo(id);
        } catch (err) {
            console.log(err);
        }
    }

    const openGameById = async (gameId) => {
        try {
            const token = localStorage.getItem('game_token');
            const response = await axios.post(base_url + '/api/gamelaunch/url',
                { token, gameId },
                {
                    withCredentials: true,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            )

            if (response?.data.success) {
                const url = response?.data.url;
                window.location.href = url;
            } else {
                toast.error('Please Login to Play.');
                setactive(true);
            }

        } catch (err) {
            console.log(err);
        }
    }

    // Initialize games on component mount
    useEffect(() => {
        handleGames();
        handleGames1();
    }, []);

    return (
        <div className='container-fluid px-3 bg-dark'>

            <div className='d-flex justify-content-between mt-3'>
                <span className=' text-center rounded' onClick={() => navigate(-1)}>
                    <i className="fas fa-arrow-left"></i>
                </span>
                <span>
                    <img src='/menu/KheloyarLogoo.png' alt='logo' />
                </span>
            </div>

            <div className='d-flex justify-content-around mt-3 gap-2 overflow-auto'>
                <div className='border pdd text-center rounded' onClick={() => navigate('/')}>
                    <img src='/menu/home.png' alt='home' />Home
                </div>
                <div className='border pdd text-center rounded' onClick={() => navigate('/inplay')}>
                    <img src='/menu/inplay.png' alt='inplay' />Inplay
                </div>
                {/* <div className='border pdd text-center rounded'>
                    <img src='/menu/exchange.png' alt='exchange' />Exchange
                </div> */}
                <div className='border pdd text-center rounded'
                 onClick={handleClicktoast2}
                >
                    <img src='/menu/sportsbook.png' alt='sportsbook' />Sports Book
                </div>
            </div>

            <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Casinos</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={handleSubmit}>
                        <img src='/menu/livecasino.png' alt='livecasino' /> Live Casino
                    </div>
                    <div className='border rounded pdd'
                     onClick={()=>navigate('/casinoGames', {state:{list:18}})}
                    >
                        <img src='/menu/tablegames.png' alt='tablegames' />Table Games
                    </div>
                    <div className='border rounded pdd'
                     onClick={()=>navigate('/casinoGames', {state:{list:5}})}
                    >
                        <img src='/menu/indian.png' alt='indian' />Indian Casino
                    </div>
                    <div className='border rounded pdd'
                    onClick={()=>navigate('/casinoGames', {state:{list:16}})}
                    >
                        <img src='/menu/slotgames.png' alt='slotgames' />Slot Games
                    </div>
                    {/* <div className='border rounded pdd'>
                        <img src='/menu/populargames.png' alt='populargames' />Popular Games
                    </div> */}
                    {/* <div className='border rounded pdd'>
                        <img src='/menu/lottery.png' alt='lottery' />Lottery
                    </div> */}
                    <div className='border rounded pdd'
                    onClick={()=>navigate('/casinoGames', {state:{list:19}})}
                    >
                        <img src='/menu/shooting.png' alt='shooting' />Shooting Games
                    </div>
                    <div className='border rounded pdd'
                   onClick={()=>navigate('/casinoGames', {state:{list:11}})}
                    >
                        <img src='/menu/crashgames.png' alt='crashgames' />crash Games
                    </div>
                    <div className='border rounded pdd'
                    onClick={()=>navigate('/casinoGames', {state:{list:13}})}
                    
                    >
                        <img src='/menu/lightning.png' alt='lightning' />Lightning
                    </div>
                    <div className='border rounded pdd'
                    onClick={()=>navigate('/casinoGames', {state:{list:15}})}
                    >
                        <img src='/menu/blackjack.png' alt='blackjack' />Black Jack
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/casinoGames')}>
                        <img src='/menu/allcasino.png' alt='allcasino' />All Casino
                    </div>
                    {/* <div className='border rounded pdd'>
                        <img src='/menu/scratch.png' alt='scratch' />Scratch games
                    </div> */}
                </div>
            </div>

            <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Multiplayer</span>

                <div className='py-3 gpp'>
                    {/* <div className='border rounded pdd'>
                        <img src='/menu/rummy.png' alt='rummy' />Rummy
                    </div> */}
                    <div className='border rounded pdd' onClick={() => ludo && openGameById(ludo)}>
                        <img src='/menu/ludo.png' alt='ludo' />Ludo
                    </div>
                    <div className='border rounded pdd'
                    onClick={() => navigate('/casinoGames', { state: { list:4 } })}
                    >
                        <img src='/menu/teenpatti.png' alt='teenpatti' />Teen Patti
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/casinoGames', { state: { list: 6 } })}>
                        <img src='/menu/multiplayer.png' alt='multiplayer' />All Multiplayer
                    </div>
                </div>
            </div>

            <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Sports</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={() => navigate("/cricketreal")}>
                        <img src='/menu/cricket.png' alt='cricket' />Cricket
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/footballreal')}>
                        <img src='/menu/soccer.png' alt='soccer' />Soccer
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/tennisreal')}>
                        <img src='/menu/tennis.png' alt='tennis' />Tennis
                    </div>
                    <div className='border rounded pdd'
                     onClick={handleClicktoast2}>
                        <img src='/menu/horseracing.png' alt='horseracing' />Horse Racing
                    </div>
                    <div className='border rounded pdd'
                     onClick={handleClicktoast2}>
                        <img src='/menu/greyhound.png' alt='greyhound' />Greyhound
                    </div>
               
                    <div className='border rounded pdd'>
                        <img src='/menu/sportsbook.png' alt='sportsbook' />Sports
                    </div>
                    <div className='border rounded pdd'
                     onClick={handleClicktoast2}>
                        <img src='/menu/virtualsports.png' alt='virtualsports' />Virtual Sports
                    </div>
                </div>
            </div>

            {/* <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>ESports</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'>
                        <img src='/menu/strike.png' alt='counterstrike' />Counter Strike
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/callofduty.png' alt='callofduty' />Call of Duty
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/data2.png' alt='data2' />Data 2
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/casinoGames', { state: { list: 20 } })}>
                        <img src='/menu/allsports.png' alt='allesports' />All ESports
                    </div>
                </div>
            </div> */}

            {/* <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Popular Games</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd' onClick={() => aviator && openGameById(aviator)}>
                        <img src='/menu/aviator.png' alt='aviator' />Aviator
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/bigballer.png' alt='bigballer' />Big Baller
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/crazytime.png' alt='crazytime' />Crazy Time
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/rouletteevo.png' alt='rouletteevo' />Roulette EVO
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/roulette.png' alt='roulette' />Roulette
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/dragontiger.png' alt='dragontiger' />Dragon Tiger
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/andarbahar.png' alt='andarbahar' />Andar Bahar
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/patti20.png' alt='patti20' />Teen Patti 20
                    </div>
                </div>
            </div> */}

            <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Providers</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'>
                        <img src='/menu/evolution.png' alt='evolution' />Evolution
                    </div>
                    {/* <div className='border rounded pdd'>
                        <img src='/menu/mac88.png' alt='mac88' />Macc88
                    </div> */}
                    <div className='border rounded pdd'>
                        <img src='/menu/qtech.png' alt='qtech' />QTech
                    </div>
                    <div className='border rounded pdd' onClick={() => navigate('/casinoGames', { state: { list: 22 } })}>
                        <img src='/menu/providers.png' alt='providers' />All Providers
                    </div>
                </div>
            </div>

            {/* <div className='border border-white rounded pt-3 mb-4'>
                <span className='p-3 fs-1'>Accessibility</span>

                <div className='py-3 gpp'>
                    <div className='border rounded pdd'>
                        <img src='/menu/blackjack.png' alt='markets' />My Markets
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/withdraw.webp' alt='withdraw' />Withdraw
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/support.webp' alt='support' />Support
                    </div>
                    <div className='border rounded pdd'>
                        <img src='/menu/setting.svg' alt='settings' />Settings
                    </div>
                </div>
            </div> */}

            {/* <button className='btn bg-yellow w-100 mb-5'>Download App</button> */}

        </div>
    )
}

export default Menu